import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {SharedModule} from '../shared/shared.module';
import {AddToQuoteMenuComponent} from './components/add-to-quote-menu/add-to-quote-menu.component';
import {ChooseQuoteComponent} from './components/choose-quote/choose-quote.component';
import {CreateNewQuoteCompoennt}  from './components/create-new-quote/create-new-quote.component';
import {EditQuoteComponent} from './components/edit-quote/edit-quote.component';
import {ListQuotesComponent} from './components/list-quotes/list-quotes.component';
import {QuoteCardComponent} from './components/quote-card/quote-card.component';
import {QuoteDetailComponent} from './components/quote-detail/quote-detail.component';
import {QuoteOrderCompleteComponent } from './components/quote-order-complete/quote-order-complete.component';
import {ReuqestQuoteComponent} from './components/request-quote/request-quote.component';
import {QuoteSideNavComponent} from './containers/quote-nav/quote-nav.component';
import {QuotesPageComponent} from './containers/quotes-page/quotes-page.component';
import {CountriesEffects} from './effects/countries.effects';
import {QuoteProductEffects} from './effects/quote-product.effects';
import {QuoteEffects} from './effects/quote.effects';
import {QuotesEffects} from './effects/quotes.effects';
import {reducers} from './reducers';
import {CountriesService} from './services/countries.service';
import {QuoteProductService} from './services/quote-product.service';
import {QuoteService} from './services/quote.service';
import {QuotesService} from './services/quotes.service';
import {MatIconModule} from '@angular/material/icon';
import {QuoteViewSelectionComponent} from './components/quote-view-selection/quote-view-selection.component';
import {CreateNewQuoteFromRootComponent} from './components/create-new-quote-from-root/create-new-quote-from-root.component';
import {CreateNewQuoteFromRootComponentLanding} from "./components/create-new-quote-from-root-landing/create-new-quote-from-root-lanidng.component";

export const ENTRY_COMPONENTS = [
    QuoteSideNavComponent
];

export const COMPONENTS = [
    ENTRY_COMPONENTS,
    QuotesPageComponent,
    ListQuotesComponent,
    QuoteCardComponent,
    QuoteDetailComponent,
    CreateNewQuoteCompoennt,
    AddToQuoteMenuComponent,
    ChooseQuoteComponent,
    EditQuoteComponent,
    ReuqestQuoteComponent,
    QuoteOrderCompleteComponent,
    QuoteViewSelectionComponent,
    CreateNewQuoteFromRootComponent,
    CreateNewQuoteFromRootComponentLanding
];

@NgModule({
    declarations: [COMPONENTS],
    imports: [
        SharedModule,
        RouterModule,
        MatIconModule,
        StoreModule.forFeature('quotes', reducers),
        EffectsModule.forFeature([QuotesEffects, QuoteEffects, QuoteProductEffects, CountriesEffects])
    ],
    exports: [COMPONENTS],
    providers: [
        QuotesService,
        QuoteService,
        QuoteProductService,
        CountriesService
    ],
})
export class QuoteListModule {
}
